module.exports = __webpack_public_path__ + "static/media/Sticker-100.c10970d0.webp";